export enum Permissions {
  //ST
  StitchingTool_SubmitStitchingResult = 3000,
  StitchingTool_General = 3010,
  StitchingTool_Admin = 3020,
  //AM
  AnnotationManager_ViewAnnotationStandard = 3400,
  AnnotationManager_ViewAnnotation = 3401,
  AnnotationManager_CreateAnnotationStandard = 3402,
  AnnotationManager_CreateAnnotation = 3403,
  AnnotationManager_AnnotationStandardAdministration = 3404,
  AnnotationManager_AnnotationStandardTemplateAdministration = 3405,
  AnnotationManager_AllowMaintenanceTriggersAPICall = 3406,
  AnnotationManager_PublishToPortal = 3407,

  AnnotationManager_ViewComments = 3408,
  AnnotationManager_AddComments = 3409,
  AnnotationManager_DeleteComments = 3410,

  AnnotationManager_ReopenTurbine = 3411,
  AnnotationManager_CloseTurbine = 3412,
  AnnotationManager_AssignTurbine = 3413,
  AnnotationManager_UnassignTurbine = 3414,
  AnnotationManager_RequestAssessment = 3415,
  AnnotationManager_UpdateAnnotation = 3416,
  AnnotationManager_DeleteAnnotation = 3417,
  AnnotationManager_DeleteAllComments = 3418,
  AnnotationManager_QAReview = 3419,
  AnnotationManager_View = 3420,
  AnnotationManager_EditComments = 3421,
  AnnotationManager_Review = 3422,
  AnnotationManager_ForceAnnotate = 3423,
  AnnotationManager_OpenPartiallyPublished = 3424,
  AnnotationManager_SetAnnotationInProgressOnOpen = 3426,
  AnnotationManager_SetResponseOnAssessment = 3427,
  AnnotationManager_DeleteAnnotationWithAssessment = 3428,

  // EngineeringAssessment permissions
  EngineeringAssessment_General = 3900,
  EngineeringAssessment_Admin = 3901,
  EngineeringAssessment_AssignAssessment = 3902,
  EngineeringAssessment_UnassignAssessment = 3903
}
